/* eslint-disable max-classes-per-file */
import { IAppointment } from '@sondermind/data-access/appointments';
import { ITherapistTemplate } from '@sondermind/utilities/models-therapist';

export class DirectScheduleSession {
  startTime: string;
  endTime: string;
  dailyAvailabilityViewHistoryId: number;
  weeklyAvailabilityHistoryId: number;
  constructor(response: IDirectScheduleSessionResponse) {
    this.startTime = response.start;
    this.endTime = response.end;
    this.dailyAvailabilityViewHistoryId = response.daily_availability_view_history_id;
    this.weeklyAvailabilityHistoryId = response.weekly_availability_history_id;
  }
}

export interface IDirectScheduleSessionResponse {
  start: string;
  end: string;
  daily_availability_view_history_id: number;
  weekly_availability_history_id: number;
}

export class DirectScheduleSessionRequest {
  locationId: number;
  startTime: string;
  endTime: string;
  dailyAvailabilityViewHistoryId: number;
  weeklyAvailabilityHistoryId: number;
  sessionType: string;
  timeProposal: boolean;
  clientGoals: string;
  clientAbout: string;

  constructor(response: IDirectScheduleSessionRequest) {
    this.locationId = response.location_id;
    this.startTime = response.start_time;
    this.endTime = response.end_time;
    this.dailyAvailabilityViewHistoryId = response.daily_availability_view_history_id;
    this.weeklyAvailabilityHistoryId = response.weekly_availability_history_id;
    this.sessionType = response.session_type;
    this.timeProposal = response.time_proposal;
    this.clientGoals = response.client_goals;
    this.clientAbout = response.client_about;
  }
}

export interface IDirectScheduleSessionRequest {
  location_id: number;
  start_time?: string;
  end_time?: string;
  daily_availability_view_history_id?: number;
  weekly_availability_history_id?: number;
  session_type?: string;
  time_proposal?: boolean;
  client_goals?: string;
  client_about?: string;
}

export type DirectScheduleInputType = {
  appointmentToReschedule?: IAppointment;
  therapist: ITherapistTemplate;
  showCloseButton?: boolean;
  clientReferralMemberId?: number;
};
